import config from "config";
import { APICore } from "helpers/api/apiCore";
import { unmaskPiiFieldByUrl } from "helpers/piiUnmask";
import { FilterMetadata } from "redux/types";
import { ApproveRejectCustomerCICReportingPayload, CreateCustomerCICReportingApiDataPayload, CreateCustomerCICReportingPayload, CustomerCICReportingDetailsPayload, CustomerCICReportingLatestVersionPayload, CustomerCICReportingVersionPayload, DeleteCustomerCICReportingPayload, UpdateCustomerCICReportingApiDataPayload, UpdateCustomerCICReportingPayload } from "./types";

const api = new APICore();

function fetchCustomerCICReportingsApi(params: FilterMetadata) {
    const baseUrl = `${config.BACKEND_BASE_URL}/customer-cic-reportings`;
    return api.get(`${baseUrl}`, params);
}

function fetchCustomerCICReportingApi(params: FilterMetadata) {
    const baseUrl = `${config.BACKEND_BASE_URL}/customer-cic-reportings/${params}`;
    return api.get(`${baseUrl}`, {});
}

function fetchCustomerCICReportingVersionApi(params: CustomerCICReportingVersionPayload) {
    const baseUrl = `${config.BACKEND_BASE_URL}/customer-cic-reportings/${params.externalID}/versions`;
    return api.get(`${baseUrl}`, params.payload);
}

function fetchCustomerCICReportingLatestVersionApi(params: CustomerCICReportingLatestVersionPayload) {
    let flag = {
        modifyLatest: params.status === "New" ? false : true
    };
    const baseUrl = `${config.BACKEND_BASE_URL}/customer-cic-reportings/${params.externalID}/latestVersion`;
    return api.get(`${baseUrl}`, flag);
}

function fetchCustomerCICReportingVersionDetailsApi(params: CustomerCICReportingDetailsPayload) {
    const baseUrl = `${config.BACKEND_BASE_URL}/customer-cic-reportings/${params.externalID}/versions/${params.Id}`;
    return api.get(`${baseUrl}`, {});
}

function createCustomerCICReportingApi(params: CreateCustomerCICReportingPayload) {
    let backendApiUrl = "";
    let apiData: CreateCustomerCICReportingApiDataPayload = {
        customerExternalId: params.customerExternalId,
        groupId: params.groupId || null,
        assetClassification: params.assetClassification || null,
        sector: params.sector || null,
        bankingArrangement: params.bankingArrangement || null,
        leadBankExternalId: params.leadBankExternalId || null,
        intRating: params.intRating || null,
        extRating: params.extRating || null,
        fraudWilful: params.fraudWilful || null,
        npaDueFgnCtryRegln: params.npaDueFgnCtryRegln === "Yes" ? true : params.npaDueFgnCtryRegln === "No" ? false : null,
        resolutionPlanStatus: params.resolutionPlanStatus || null,
        dateFilingNclt: params.dateFilingNclt || null,
        dateAdmissionNclt: params.dateAdmissionNclt || null,
        techWoOuts: params.techWoOuts || null,
        twoDate: params.twoDate || null,
        secFundAmt: params.secFundAmt || null,
        assetClassificationCibilRaw: params.assetClassificationCibilRaw || null,
        accountStatusRaw: params.accountStatusRaw || null,
        suitFiledStatusRaw: params.suitFiledStatusRaw || null,
        suitAmount: params.suitAmount || null,
        dateOfSuit: params.dateOfSuit || null,
        wilfulDefaultStatus: params.wilfulDefaultStatus === "Yes" ? true : params.wilfulDefaultStatus === "No" ? false : null,
        dateClassifiedAsWilfulDefault: params.dateClassifiedAsWilfulDefault || null,
        businessCategoryRaw: params.businessCategoryRaw || null,
        businessOrIndustryTypeRaw: params.businessOrIndustryTypeRaw || null,
        individualNamePrefix: params.individualNamePrefix || null,
        fullName: params.fullName || null,
        genderRaw: params.genderRaw || null,
        pan: params.pan || null,
        dateOfBirth: params.dateOfBirth || null
    };
    if (!params.draft) {
        apiData.makerRemarks = params.makerRemarks || "";
        backendApiUrl = `${config.BACKEND_BASE_URL}/customer-cic-reportings`;
    } else {
        backendApiUrl = `${config.BACKEND_BASE_URL}/customer-cic-reportings?draft=${params.draft}`;
    }
    const baseUrl = backendApiUrl;
    return api.create(`${baseUrl}`, apiData);

}

function updateCustomerCICReportingApi(params: UpdateCustomerCICReportingPayload) {
    let backendApiUrl = "";

    let apiData: UpdateCustomerCICReportingApiDataPayload = {
        customerExternalId: params.customerExternalId,
        groupId: params.groupId || null,
        assetClassification: params.assetClassification || null,
        sector: params.sector || null,
        bankingArrangement: params.bankingArrangement || null,
        leadBankExternalId: params.leadBankExternalId || null,
        intRating: params.intRating || null,
        extRating: params.extRating || null,
        fraudWilful: params.fraudWilful || null,
        npaDueFgnCtryRegln: params.npaDueFgnCtryRegln ?? null,
        resolutionPlanStatus: params.resolutionPlanStatus || null,
        dateFilingNclt: params.dateFilingNclt || null,
        dateAdmissionNclt: params.dateAdmissionNclt || null,
        techWoOuts: params.techWoOuts || null,
        twoDate: params.twoDate || null,
        secFundAmt: params.secFundAmt || null,
        assetClassificationCibilRaw: params.assetClassificationCibilRaw || null,
        accountStatusRaw: params.accountStatusRaw || null,
        suitFiledStatusRaw: params.suitFiledStatusRaw || null,
        suitAmount: params.suitAmount || null,
        dateOfSuit: params.dateOfSuit || null,
        wilfulDefaultStatus: params.wilfulDefaultStatus ?? null,
        dateClassifiedAsWilfulDefault: params.dateClassifiedAsWilfulDefault || null,
        businessCategoryRaw: params.businessCategoryRaw || null,
        businessOrIndustryTypeRaw: params.businessOrIndustryTypeRaw || null,
        individualNamePrefix: params.individualNamePrefix || null,
        fullName: params.fullName || null,
        genderRaw: params.genderRaw || null,
        pan: params.pan || null,
        dateOfBirth: params.dateOfBirth || null
    };
    if (!params.draft) {
        apiData.makerRemarks = params.makerRemarks ? params.makerRemarks : "";
        backendApiUrl = `${config.BACKEND_BASE_URL}/customer-cic-reportings/${params.externalId}`;
    } else {
        backendApiUrl = `${config.BACKEND_BASE_URL}/customer-cic-reportings/${params.externalId}?draft=${params.draft}`;
    }
    const baseUrl = backendApiUrl;
    return api.update(`${baseUrl}`, apiData);

}

function deleteCustomerCICReportingApi(params: DeleteCustomerCICReportingPayload) {
    const baseUrl = `${config.BACKEND_BASE_URL}/customer-cic-reportings/${params.externalId}`;
    return api.delete(`${baseUrl}`);
}

function approveCustomerCICReportingApi(params: ApproveRejectCustomerCICReportingPayload) {
    let remarks = {
        checkerRemarks: params.checkerRemarks.trim()
    };
    const baseUrl = `${config.BACKEND_BASE_URL}/customer-cic-reportings/${params.externalId}/approve`;
    return api.updatePatch(`${baseUrl}`, remarks);
}

function rejectCustomerCICReportingApi(params: ApproveRejectCustomerCICReportingPayload) {
    let remarks = {
        checkerRemarks: params.checkerRemarks.trim()
    };
    const baseUrl = `${config.BACKEND_BASE_URL}/customer-cic-reportings/${params.externalId}/reject`;
    return api.updatePatch(`${baseUrl}`, remarks);
}

function publishCustomerCICReportingApi(params: { externalId: string; makerRemarks: string }) {
    const baseUrl = `${config.BACKEND_BASE_URL}/customer-cic-reportings/${params.externalId}/publish`;
    return api.updatePatch(baseUrl, { makerRemarks: params.makerRemarks.trim() });
}

function unmaskCustomerCICReportingPiiFieldApi(recordId: string, fieldName: string) {
    return unmaskPiiFieldByUrl(`${config.BACKEND_BASE_URL}/customer-cic-reportings/${recordId}/pii/unmask`, fieldName);
}

export {
    fetchCustomerCICReportingsApi,
    fetchCustomerCICReportingApi,
    fetchCustomerCICReportingVersionApi,
    fetchCustomerCICReportingLatestVersionApi,
    fetchCustomerCICReportingVersionDetailsApi,
    createCustomerCICReportingApi,
    updateCustomerCICReportingApi,
    deleteCustomerCICReportingApi,
    approveCustomerCICReportingApi,
    rejectCustomerCICReportingApi,
    publishCustomerCICReportingApi,
    unmaskCustomerCICReportingPiiFieldApi
}